import { funcType } from '@lc/types/Misc';

import { Summit, SummitVerbose } from './types';

export function createCardSummit(
	id: number = -1,
	description: string = ``,
	type: string = ``, // whoops, this means "on turn or at winter summit"
	modifier: string = ``,
	cost: number = 0
): Summit {
	// const type = 'Summit';

	return {
		id,
		description,
		type,
		modifier,
		cost,
	};
}

export function createCardSummitVerbose(
	summit: Summit,
	action: funcType
): SummitVerbose {
	return {
		...summit,
		action,
	};
}
